import { render, staticRenderFns } from "./structureCopy.vue?vue&type=template&id=077ac249&scoped=true&"
import script from "./structureCopy.vue?vue&type=script&lang=js&"
export * from "./structureCopy.vue?vue&type=script&lang=js&"
import style0 from "./structureCopy.vue?vue&type=style&index=0&id=077ac249&scoped=true&lang=css&"
import style1 from "./structureCopy.vue?vue&type=style&index=1&id=077ac249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077ac249",
  null
  
)

export default component.exports